import { css } from 'emotion'

export const marginTopSmallStyles = css`
  margin-top: 8px;
`
